import { useTransitionGuard } from "@/context/Transitions";

interface ShakeButtonProps {
  onShake: () => void;
  disabled?: boolean;
}

export function ShakeButton({ onShake, disabled }: ShakeButtonProps) {
  const { trigger } = useTransitionGuard();

  return (
    <button
      type="button"
      onClick={() => trigger('shake', { onContinue: onShake })}
      disabled={disabled}
      className="btn border w-full py-3 px-4 lg:py-3 text-sm lg:text-base font-semibold rounded-full lg:rounded-[10px] transition-all duration-150 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:shadow-none"
    >
      Shake it up
    </button>
  );
}
